/* eslint no-nested-ternary: 0 */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router';
import { Trans, withTranslation } from 'react-i18next';
import {
  Feed,
  Grid,
  List,
} from 'semantic-ui-react';
import moment from 'moment-timezone';
import { camelToTitle } from '../utils/strings';
import { parseJSON } from '../utils/json';
import { getConstantsLabel, translateModels } from '../utils/translation';
import { namespaces, TRANSLATION_FILES } from '../constants/translation';
import Timestamp from './Timestamp';

// Still needed for the module-level locale; the feed date renders through Timestamp.
moment.locale('en-gb');

class UserActivities extends Component {
  static propTypes = {
    data: PropTypes.arrayOf(PropTypes.object).isRequired,
    hasAccess: PropTypes.bool,
    loading: PropTypes.bool,
    showAll: PropTypes.bool,
  }
  translateGroupsToName = (groups) => {
    const { t } = this.props;
    let text;
    const accessRoles = [
      { text: 'Headquarters', values: [10, 6], description: 'Admin' },
      { text: 'Supervisor', values: [10, 11, 12, 13], description: 'BU Leader' },
      { text: 'Sales Manager', values: [10, 11, 13], description: 'BU Leader' },
      { text: 'Sales Admin', values: [10, 11], description: 'BU Leader' },
      { text: 'Agency Admin', values: [10, 21], description: 'Claim C.' },
      { text: 'Agent Leader', values: [10, 17] },
      { text: 'Agent / Staff', values: [10] },
      { text: 'Basic Siteplan', values: [16] },
    ];
    accessRoles.forEach((ar) => {
      const result = ar.values.every(word => groups.indexOf(word.toString()) > -1);
      if (result && !text) text = `${t(ar.text, { ns: TRANSLATION_FILES.constants })} ${ar.description ? `(${t(ar.description, { ns: TRANSLATION_FILES.constants })})` : ''}`;
    });
    if (!text) text = groups;
    return text;
  }
  translateStatusToName = (statusId) => {
    const { t } = this.props;
    const userStatuses = [
      { text: 'Active', value: 100 },
      { text: 'Suspended', value: 503 },
    ];
    const status = userStatuses.find(s => s.value === statusId);
    return status ? t(status.text, { ns: TRANSLATION_FILES.constants }) : null;
  }
  renderActivityMessage = (activity) => {
    const { t } = this.props;
    const activityBefore = parseJSON(activity.before);
    const activityAfter = parseJSON(activity.after);
    const afterKeys = Object.keys(activityAfter);
    const changes = [];
    afterKeys.forEach((element) => {
      let message;
      let after = '';
      let before = activityBefore[element];
      if (activity.before) {
        after = activityAfter[element];
      }
      switch (element) {
        case 'groups':
          before = activity.before ? this.translateGroupsToName(activity.before) : null;
          after = activity.after ? this.translateGroupsToName(activity.after) : null;
          break;
        case 'statusID':
          before = activity.before ? this.translateStatusToName(before) : null;
          after = activity.after ? this.translateStatusToName(after) : null;
          break;
        case 'isOldUser':
        case 'loginAttempt':
        case 'profileImageSrc':
        case 'name':
        case 'preferredName':
        case 'email':
        case 'mobile':
        case 'mobilePrefix':
        case 'officeTel':
        case 'officeTelPrefix':
          before = null;
          after = null;
          break;
        default:
          break;
      }
      if (message) {
        changes.push(message);
      } else if (before || after) {
        const keyName = translateModels(t, element, 'user', camelToTitle(element));
        if (before === false && after) {
          message = (
            <Trans ns={TRANSLATION_FILES.screens}>
              <span><span style={{ color: '#666' }}>{{ keyName }}</span> has been added</span>
            </Trans>
          );
        } else if (!before) {
          message = <span><span style={{ color: '#666' }}>{keyName}</span>: <u>{after}</u></span>;
        } else if (before && !after) {
          message = (
            <Trans ns={TRANSLATION_FILES.screens}>
              <span><span style={{ color: '#666' }}>{{ keyName }}</span> has been removed</span>
            </Trans>
          );
        } else {
          message = (
            <Trans ns={TRANSLATION_FILES.screens}>
              <span><span style={{ color: '#666' }}>{{ keyName }}</span> changed from <u>{{ before }}</u> to <u>{{ after }}</u></span>
            </Trans>
          );
        }
        changes.push(message);
      }
    });
    return (
      <List bulleted>
        {changes.map((element, id) => (
          <List.Item key={id}>
            {element}
          </List.Item>
        ))}
      </List>
    );
  };
  render() {
    const { data, t } = this.props;
    return (
      <Grid>
        <Grid.Row>
          <Grid.Column width={16}>
            <Feed>
              { data && data.length > 0 ?
              data.map((activity, idx) => (
                <Feed.Event key={idx} className="activity-logs">
                  <Feed.Label icon="user" />
                  <Feed.Content>
                    <Feed.Date>
                      <Timestamp timestamp={activity.createdAt} format="MMMM Do YYYY, h:mm:ss a" />
                    </Feed.Date>
                    <Feed.Summary>
                      {this.props.hasAccess ?
                        activity.creatorAffiliateID > 0 ?
                          <Link to={`/users/${activity.creatorAffiliateID}/`}>
                            {activity.creatorPreferredName || t('Unknown')}
                          </Link>
                           : (activity.creatorPreferredName || `U${activity.creatorUserID}`)
                         : (activity.creatorPreferredName || `U${activity.creatorUserID}`)
                      }
                      {` ${t(activity.message)}`}
                      {this.props.showAll && (
                        <Link to={`/users/${activity.userAffiliateID}/`}>
                          {` ${activity.userPreferredName || `U${activity.userID}`}`}
                        </Link>
                      )}
                    </Feed.Summary>
                    <Feed.Extra text>
                      { activity.after && this.renderActivityMessage(activity) }
                    </Feed.Extra>
                  </Feed.Content>
                </Feed.Event>
              )) :
                this.props.loading ?
                  <br />
                : <center>{t('No activity found')}.</center>
              }
            </Feed>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    );
  }
}
export default withTranslation([...namespaces, TRANSLATION_FILES.models.user])(UserActivities);



// WEBPACK FOOTER //
// ./src/components/UserActivities.jsx